import reduceReducers from 'reduce-reducers';

import { withDataRequest } from 'app/dealer/shared/higherOrderReducers/withDataRequest/withDataRequest.reducer';

import { defaultState } from './reducer.defaultState';
import { LISTINGS_BENCHMARK_REDUCER_NAME } from './constants';
import { general } from './general/reducer';
import { listings } from './listings/reducer';
import { topListings } from './topListings/reducer';
import { listingsImages } from './listingsImages/reducer';
import { timeDivision } from './timeDivision/reducer';
import { authStatus } from './authStatus/reducer';
import { listingsTurnover } from './listingsTurnover/reducer';

const reducerList = [
  defaultState(),
  general,
  authStatus,
  listings,
  listingsImages,
  topListings,
  listingsTurnover,
  timeDivision,
];

export const listingsBenchmark = withDataRequest(
  reduceReducers(...reducerList),
  LISTINGS_BENCHMARK_REDUCER_NAME,
);
